export const BASE_CLASS = 'mt-ModalBasicContent'
export const STEPS_INITIAL_STATE = 0
export const TEST_ID = 'step-button-id'
